"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as r, jsx as h } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as c } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: l, size: a = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = c(), e = l !== null && l !== void 0 ? l : i ? t.colors.inverse : t.colors.neutralHigh, { skinName: s } = n();
    return s.match(/^o2-new/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ h("path", {
                fill: e,
                d: "m15.076 2.572 4.363 4.492A2 2 0 0 1 20 8.448v11.048a.706.706 0 0 1-.697.716.706.706 0 0 1-.698-.716V8.444a.54.54 0 0 0-.152-.372l-4.367-4.488a.5.5 0 0 0-.362-.156H8.336a.52.52 0 0 0-.514.528V4.5h4.519c.502 0 .993.208 1.348.572l3.323 3.42c.35.364.553.868.553 1.38V22H4V6.456C4 5.376 4.853 4.5 5.905 4.5h.53v-.544C6.435 2.876 7.288 2 8.34 2h5.388a1.9 1.9 0 0 1 1.348.572m.946 6.924-3.315-3.412a.5.5 0 0 0-.362-.156h-6.44a.52.52 0 0 0-.514.528v14.116h10.783v-10.7a.56.56 0 0 0-.152-.376"
            }),
            /* @__PURE__ */ h("path", {
                fill: e,
                d: "M13.83 10.928c.716 0 1.3.6 1.3 1.336h-.004V19.5H6.431v-7.236c0-.736.584-1.336 1.301-1.336zm-6.004 7.144h5.914v-5.716H7.826z"
            })
        ]
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ h("path", {
                fill: e,
                d: "m15.076 2.572 4.363 4.492A2 2 0 0 1 20 8.448v11.048a.706.706 0 0 1-.697.716.706.706 0 0 1-.698-.716V8.444a.54.54 0 0 0-.152-.372l-4.367-4.488a.5.5 0 0 0-.362-.156H8.336a.52.52 0 0 0-.514.528V4.5h4.519c.502 0 .993.208 1.348.572l3.323 3.42c.35.364.553.868.553 1.38V22H4V6.456C4 5.376 4.853 4.5 5.905 4.5h.53v-.544C6.435 2.876 7.288 2 8.34 2h5.388a1.9 1.9 0 0 1 1.348.572m.946 6.924-3.315-3.412a.5.5 0 0 0-.362-.156h-6.44a.52.52 0 0 0-.514.528v14.116h10.783v-10.7a.56.56 0 0 0-.152-.376"
            }),
            /* @__PURE__ */ h("path", {
                fill: e,
                d: "M13.83 10.928c.716 0 1.3.6 1.3 1.336h-.004V19.5H6.431v-7.236c0-.736.584-1.336 1.301-1.336zm-6.004 7.144h5.914v-5.716H7.826z"
            })
        ]
    }));
}, u = v;
export { u as default };
